import { render } from "./About.vue?vue&type=template&id=dee451b0"
const script = {}

import exportComponent from "/Users/sindreglomnes/Documents/Dataing/Testing/VueCourse/real-world-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__